import AppleButton from '@/next/components/AppleButton/AppleButton';

export default AppleButton;
